const upButtons = document.querySelectorAll('.j-button-up');

upButtons.forEach((button: Element) => {
    button.addEventListener('click', () => {
        window.scrollTo({
            top     : 0,
            left    : 0,
            behavior: 'smooth'
        });
    });
});
